module.exports = __webpack_public_path__ + "img/DSC_0180 teatro 2.6dd2529f.jpg";